<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="container-legal-reference modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.EDIT_LEGAL_REFERENCE
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close(false)">
        <b-icon icon="close" />
      </div>
    </header>

    <h3
      v-if="mandatory"
      class="is-size-6 has-text-centered has-text-weight-semibold has-text-color-7"
    >
      {{ General.MESSAGES.CHANGE_SECRECY_PROCESS }}
    </h3>

    <h4
      class="is-size-7 has-text-centered has-text-weight-semibold has-text-color-7 p-20"
      v-html="General.TEXTS.DESCRIPTION_LEGAL_REFERENCE_MODAL"
    />

    <div class="modal-content-container p-20">
      <b-field customClass="has-text-color-7" :label="General.LEGAL_REFERENCE">
        <CustomTagInput
          v-model="legal_reference"
          :data="listReferences"
          autocomplete
          :placeholder="General.TYPE_IT_LEGAL_REFERENCE"
          :beforeAdding="beforeAddingLegalReference"
          name="legalReference"
          class="is-10"
          rounded
          @typing="setLegalReference"
        >
          <template slot-scope="props">
            <div
              class="pre-wrap"
              :class="{ 'custom-class-add': !props.option.id }"
            >
              {{ props.option.description }}
            </div>
          </template>
          <template #selected="props">
            <b-tag
              v-for="tag in listFromSubject"
              :key="`subject_ref_${tag.id}`"
              rounded
              :tabstop="false"
              closable
              class="tag-custom"
              @close="showMessageSecrecy"
            >
              {{ tag.description }}
            </b-tag>
            <b-tag
              v-for="tag in props.tags"
              :key="`user_ref_${tag.id}`"
              rounded
              :tabstop="false"
              closable
              class="tag-custom has-text-blue-oil tag-user-add"
              type="is-white"
              @close="legal_reference.splice(index, 1)"
            >
              {{ tag.description }}
            </b-tag>
          </template>
        </CustomTagInput>
      </b-field>
    </div>

    <footer class="modal-card-foot is-justify-content-flex-end">
      <div class="buttons">
        <b-button
          :type="isContrast ? 'is-white-dark' : 'is-primary'"
          @click="include"
        >
          {{ General.SAVE }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white-dark' : 'is-warning'"
          outlined
          @click="close(false)"
        >
          {{ General.CANCEL }}
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import { General } from "@/utils/constants";
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";
import cloneDeep from "lodash/cloneDeep";
import { mapActions, mapGetters } from "vuex";
import ModalCreateLegalReference from "@/views/App/ModalCreateLegalReference.vue";

export default {
  name: "ModalLegalReference",

  props: {
    list: {
      required: true,
      type: Array
    },
    listFromSubject: {
      required: true,
      type: Array
    },
    change: {
      type: Function,
      default: () => null
    },
    mandatory: {
      type: Boolean,
      default: () => false
    },
    process: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      General,
      filterLegalReference: "",
      legal_reference: []
    };
  },

  computed: {
    ...mapGetters({
      getFilteredLegalReference: "getFilteredLegalReference",
      hasPermission: "hasPermission",
      isContrast: "isContrast"
    }),

    listReferences() {
      const addItens = this.hasPermissionCreateLegalReference
        ? [
            {
              description: `+ ${this.General.ADD_NEW_LEGAL_REFERENCE.toLowerCase()}`,
              id: 0
            }
          ]
        : [];
      return [
        ...this.getFilteredLegalReference(this.filterLegalReference),
        ...addItens
      ];
    },

    hasPermissionCreateLegalReference() {
      return this.hasPermission(userPermissions["CREATE_LEGAL_REFERENCE"]);
    }
  },

  beforeMount() {
    const subjectRefIds = this.listFromSubject.map(ref => ref.id);
    const personalRefs = this.list.filter(
      item => !subjectRefIds.includes(item.id)
    );
    this.legal_reference = cloneDeep(personalRefs);
  },

  methods: {
    ...mapActions({
      createLegalReference: "legalReferenceCreate"
    }),

    setLegalReference(text) {
      this.filterLegalReference = text;
    },

    beforeAddingLegalReference(tag) {
      if (tag.id === 0) {
        this.$buefy.modal.open({
          parent: this,
          component: ModalCreateLegalReference,
          props: {
            create: tag => {
              this.newLegalReference(tag);
            }
          },
          hasModalCard: true,
          trapFocus: true
        });

        return false;
      }
      return !this.legal_reference.find(
        legalReference => legalReference.description === tag.description,
        false
      );
    },

    close(success) {
      !success && this.$parent.onCancel();
      this.$parent.close();
    },

    async newLegalReference(tag) {
      if (typeof tag === "string") {
        const exist = this.getFilteredLegalReference(tag).length;
        if (!exist) {
          const objTemp = {
            description: tag,
            secrecy: null
          };
          const result = await this.createLegalReference(objTemp);
          this.legal_reference.push({
            ...result,
            description_trunc: objTemp.description.replace(/ \(.+/g, "")
          });
        }
      }
    },

    include() {
      this.change(this.legal_reference);
      this.close(true);
    },

    showMessageSecrecy() {
      this.snackToast.open({
        message: this.General.MESSAGES.ALERT_REMOVE_LEGAL_REFERENCE,
        type: "is-warning",
        duration: 8000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  background-color: $color-1;
  min-height: 60vh;
  max-height: 75vh;
  width: 950px;
  max-width: 100%;
  overflow: auto;
}

.modal-card-head,
.modal-card-foot {
  background-color: $color-1;
  border: none;
}

.tag-custom {
  white-space: normal;
  height: auto !important;
}
</style>

<style lang="scss">
.container-legal-reference {
  ::-webkit-scrollbar {
    width: 10px;
  }
  .taginput .taginput-container > .tag {
    font-size: 1rem !important;
  }
}
</style>
